<sync-dialog
  [open]="isDialogOpen"
  [config]="{
    isClosable: false,
  }"
>
  <div class="LinkInfoDialog">
    <sync-spinner></sync-spinner>
    <p class="subtitle-1">{{ modalText }}</p>
  </div>
</sync-dialog>
